<app-navbar></app-navbar>

<!-- Page Banner -->
<div class="rs-page-banner">
  <div class="rs-pb-deco">
    <div class="rs-pb-dots"></div>
    <div class="rs-pb-circle rs-pb-c1"></div>
    <div class="rs-pb-circle rs-pb-c2"></div>
  </div>
  <div class="container">
    <div class="rs-pb-content">
      <h1 class="rs-pb-title">{{ foundnews?.TitleEn || 'Achievement Detail' }}</h1>
      <nav class="rs-pb-breadcrumb">
        <a routerLink="/">Home</a>
        <i class="ri-arrow-right-s-line"></i>
        <a routerLink="/achievements">Achievements</a>
        <i class="ri-arrow-right-s-line"></i>
        <span>Detail</span>
      </nav>
    </div>
  </div>
</div>

<!-- Content -->
<div class="rs-inner-page">
  <div class="container" *ngIf="foundnews">
    <div class="rs-inner-card">

      <!-- Image grid -->
      <div class="rs-detail-images" *ngIf="foundnews.ShowAttachments?.length">
        <div class="rs-detail-img-item wow fadeIn"
             *ngFor="let img of foundnews.ShowAttachments; let i = index"
             [attr.data-wow-delay]="(i * 0.08) + 's'">
          <a [href]="img.FilePath" target="_blank">
            <img [src]="img.FilePath" [alt]="img.FilePath" class="popup-btn">
          </a>
        </div>
      </div>

      <!-- Text content -->
      <div class="rs-detail-body" [innerHTML]="foundnews.DetailsEn"></div>

    </div>
  </div>

  <div class="container" *ngIf="!foundnews">
    <div class="rs-empty-state">
      <i class="ri-medal-line"></i>
      <h4>Achievement not found</h4>
    </div>
  </div>
</div>
